import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { fetchTivProfileMemory } from '../../api/tiv';

const TYPE_LABELS = {
  onboarding: 'Onboarding',
  values:     'Mes Valeurs',
  riasec:     'Mes Intérêts',
  jourda:     'Mes Énergies',
  im:         'Mes Intelligences',
};

export default function TivProfilePanel({ open, onClose }) {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    fetchTivProfileMemory()
      .then(setItems)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  const tivItems   = items.filter(i => i.type === 'tiv');
  const otherItems = items.filter(i => i.type !== 'tiv');

  // Grouper les items tiv par lettre
  const tivGroups = {};
  for (const item of tivItems) {
    const key = item.tiv_conversation?.title || 'Sans titre';
    if (!tivGroups[key]) tivGroups[key] = [];
    tivGroups[key].push(item);
  }

  // Grouper les autres par type
  const otherGroups = {};
  for (const item of otherItems) {
    if (!otherGroups[item.type]) otherGroups[item.type] = [];
    otherGroups[item.type].push(item);
  }

  return (
    <div className="fixed inset-0 z-50 flex justify-end" onClick={onClose}>
      <div
        className="w-full max-w-sm bg-gray-900 border-l border-white/[0.06] h-full overflow-y-auto flex flex-col"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 pb-3 pt-8 shrink-0">
          <div>
            <h2 className="text-base font-bold text-white">Profil Tiv</h2>
            <p className="text-xs text-zinc-500 mt-2.5 pr-5">Tout ce que Tiv sait de toi. Plus c'est riche, plus tes lettres te ressemblent.</p>
          </div>
          <button
            onClick={onClose}
            className="absolute right-5 top-5 p-1.5 rounded-lg hover:bg-white/[0.05] text-zinc-400 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-5 py-5 flex flex-col gap-6">
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="w-5 h-5 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
            </div>
          ) : items.length === 0 ? (
            <p className="text-sm text-zinc-600 text-center py-10">Tiv n'a pas encore de profil pour toi.</p>
          ) : (
            <>
              {/* Section Tiv */}
              {Object.keys(tivGroups).length > 0 && (
                <div>
                  <h3 className="text-xs font-bold text-emerald-400 uppercase tracking-widest mb-3">Ce que Tiv a appris en discutant</h3>
                  <div className="flex flex-col gap-2">
                    {Object.entries(tivGroups).map(([letterTitle, group]) => (
                      <div key={letterTitle}>
                        <div className="flex flex-col gap-2">
                          {group.map(item => (
                            <div key={item.id} className="bg-emerald-500/[0.05] border border-emerald-500/[0.12] rounded-xl px-4 py-3">
                              <p className="text-sm font-semibold text-zinc-200 mb-1">{item.title}</p>
                              <p className="text-xs text-zinc-400 leading-relaxed">{item.description}</p>
                              <p className="text-[11px] text-zinc-600 mt-1.5">Source : {item.tiv_conversation?.title}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Section questionnaires */}
              {Object.keys(otherGroups).length > 0 && (
                <div>
                  <h3 className="text-xs font-bold text-violet-400 uppercase tracking-widest mb-3">Questionnaires</h3>
                  <div className="flex flex-col gap-2">
                    {Object.entries(otherGroups).map(([type, group]) => (
                      <div key={type}>
                        <div className="flex flex-col gap-2">
                          {group.map(item => (
                            <div key={item.id} className="bg-violet-500/[0.04] border border-violet-500/[0.10] rounded-xl px-4 py-3">
                              <p className="text-sm font-semibold text-zinc-200 mb-1">{item.title}</p>
                              <p className="text-xs text-zinc-400 leading-relaxed">{item.description}</p>
                              <p className="text-[11px] text-zinc-600 mt-1.5">Source : {TYPE_LABELS[item.type] || item.type}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
